var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 14C2.82736 13.2141 0 9.87764 0 6.36364V2.54545L6.36364 0L12.7273 2.54545V6.36364C12.7273 9.87891 9.89991 13.2141 6.36364 14ZM1.27273 3.18182V6.36364C1.30909 7.83499 1.82659 9.2539 2.74602 10.4032C3.66545 11.5525 4.93615 12.3688 6.36364 12.7273C7.79112 12.3688 9.06182 11.5525 9.98125 10.4032C10.9007 9.2539 11.4182 7.83499 11.4545 6.36364V3.18182L6.36364 1.27273L1.27273 3.18182Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36483 6.36334C7.24347 6.36334 7.95574 5.65106 7.95574 4.77243C7.95574 3.89379 7.24347 3.18152 6.36483 3.18152C5.4862 3.18152 4.77393 3.89379 4.77393 4.77243C4.77393 5.65106 5.4862 6.36334 6.36483 6.36334Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18311 8.90909C3.49666 9.48076 3.95654 9.95881 4.51564 10.2943C5.07473 10.6297 5.71295 10.8105 6.36492 10.8182C7.01689 10.8105 7.65511 10.6297 8.21421 10.2943C8.77331 9.95881 9.23319 9.48076 9.54674 8.90909C9.53083 7.70255 7.42001 7 6.36492 7C5.30411 7 3.19901 7.70255 3.18311 8.90909Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.1541a1418d20fd893959916bc2dc9bc8.svg";
export { ForwardRef as ReactComponent };